<template>
    <div class="ji_fen">
        <div class="top_bar">
            <div class="tab_box">
                <div class="tab_item" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active_tab' : '' " @click="TabClick(item, index)" >
                    {{ item }}
                </div>
            </div>
            <!-- <div class="btn_box">
                <el-select v-model="type" placeholder="进行中">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
        </div>

        <div class="list_box" v-if="!isContinue && list && list.length">
            <div class="list_item" v-for="(item, index) in list" :key="index">
                <div class="left_box">
                    <img src="../../assets/static/index/default.png" alt="">
                    <div class="info_box">
                        <div class="title" @click="continueStudy( item )">{{ item.themeTitle }}</div>
                        <div class="right_count">
                            <span class="rights">学习{{ item.time }}分钟</span>
                        </div>
                        <div class="time">
                            <!-- <span class="iconfont icon-shijian"></span> -->
                            <span>共{{ item.totalSize }}章</span>
                        </div>
                    </div>
                </div>
                <div class="right_box" >
                    <div class="fen">
                        <!-- <span class="small">已学: </span> <span class="big">{{ item.percentage }}%</span> -->
                    </div>
                    <div class="btn_box">
                        <el-button @click="continueStudy( item )">继续学习 > </el-button>
                    </div>
                </div>
            </div>
            <div class="page_box" v-if="list && list.length">
                <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="totalPage * pageSize ">
                </el-pagination>
            </div>
        </div>

        


        <!-- 学习记录 -->
        <div class="jilu_box" v-if="isContinue && activeItem">
            <!-- 继续学习的课程 -->
             <div class="list_item" >
                <div class="left_box">
                    <img src="../../assets/static/index/default.png" alt="">
                    <div class="info_box">
                        <div class="title">{{ activeItem.themeTitle }}</div>
                        <div class="right_count">
                            <span class="rights">用时{{ activeItem.time }}分钟</span>
                        </div>
                        <div class="time">
                            <!-- <span class="iconfont icon-shijian"></span> -->
                            <span>共{{ activeItem.totalSize }}章</span>
                        </div>
                    </div>
                </div>
                <div class="right_box" >
                    <div class="fen">
                        <!-- <span class="small">已学: </span> <span class="big">{{ activeItem.percentage }}%</span> -->
                    </div>
                    <div class="btn_box">
                        <el-button @click="goback">返回 > </el-button>
                    </div>
                </div>
            </div>

            <!-- 记录列表 -->
            <div class="mulu_box" v-if="MuLuList && MuLuList.length">
                <div class="mulu_item" v-for="(item, index) in MuLuList" :key="index" @click="showDetail( item )">
                    <div class="mulu_title">
                       <span class="iconfont icons icon-icon_kaishixuexi_hover"></span> {{ item.schoolTitle }}
                    </div>
                    <div class="mulu_jindu">
                        <span class="txt">{{ item.is_finish == 1 ? "已完成" : "未完成"  }}</span>
                        <div class="jindu_tiao ">
                            <span class="iconfont" :class="item.is_finish == 1 ? 'icon-querenyuanzhengqueduigoutijiaochenggongwancheng' : 'icon-xuexizhong gray' "></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page_box" style="text-align:right;margin-top: 20px;">
                <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="totalPage * pageSize ">
                </el-pagination>
            </div>


        </div>

        <no-more v-if="list.length == 0 && !isContinue"></no-more>

    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TabList: ["进行中", "已完成"],
            
                TabCur: 0,
                list: [

                ],
                 options: [{
                        value: '0',
                        label: '进行中'
                        }, {
                        value: '1',
                        label: '已完成'
                        }
                    ],
                formData: {
                    title: "",
                    content: "",
                    cate: "",
                    rule: ""
                },
                type: "0",
                pageNum: 1,
                pageSize: 10,
                totalPage: 0,
                activeItem: {}, // 点击继续学习的课程
                JiLuList:[], // 学习记录
                isContinue: false, // 是否继续学习
                MuLuList: [], // 目录列表
            }
        },
        computed: {
           ...mapGetters(['token']),
           typeName () {
               if ( this.type == 0 ) {
                   return "进行中"
               } else {
                   return "已完成"
               }
           },
        },
        watch: {
            type () {
                this.getMyKe()
            },
        },
        mounted () {
            this.getMyKe();
        },
        methods: {
            // 点击tab
            TabClick(item, index) {
                this.isContinue = false
                this.TabCur = index
                this.type = `${index}`
                this.getMyKe()
            },
            // 获取我的课程
            async getMyKe () {
                this.list = []
                this.activeItem = {}
                let { token, type, pageNum, pageSize } = this
                let res = await this.$axios.post("/lencon/pc/person/mySchool", { token, type, pageNum, pageSize })
                if ( res.data.code == 1 ) {
                    this.list = res.data.data
                    this.totalPage = res.data.totalPages
                }
            },

            // 继续学习
            continueStudy ( item ) {
                this.$router.push(`/StudyDetail/${ item.id }`)
                // console.log( item )
                // this.pageNum = 1
                // this.activeItem = item 
                // this.isContinue = true
                // this.getmulu( item.id )
            },
            // 回去课程目录
            async getmulu ( schoolThemeId ) {
                this.MuLuList = []
                let { token, pageNum, pageSize } = this 
                let res = await this.$axios.post("/lencon/pc/person/school_catalog", { token, pageNum, pageSize, schoolThemeId })
                if ( res.data.code == 1 ) {
                    this.MuLuList = res.data.data
                    this.totalPage = res.data.totalPages
                }
            },
            // 展示学习详情
            showDetail ( item ) {
                this.$router.push(`/StudyDetail/${ item.school_id }`)
            },
            // 返回
            goback () {
                this.isContinue = false
            },
            // 课程目录
            async getDir() {
                let res = await this.$axios.post("/lencon/pc/person/school_catalog")
                if ( res.data.code == 1 ) {
                    this.options = res.data.res
                }
            }

        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
}
</style>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.gray {
    color: #b3b3b3 !important; 
}
.ji_fen {
    width: 980px;
    padding: 20px;
    box-sizing: border-box;
    .top_bar {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom:1px solid #eeeeee;
        .tab_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            .tab_item {
                width: 120px;
                text-align: center;
                padding-bottom: 10px;
                cursor: pointer;
            }
            .active_tab {
                color: #2767c4 ;
                border-bottom: 2px solid #2767c4 ;
            }
        }
        .btn_box {
            .study_btn {
                background: #EEEEEE;
                border-radius: 5px;
            }
            .shenbao_btn {
                background: #2767c4 ;
                border-radius: 5px;
                color: #fff;
            }
        }
    }
    .list_box {
        width: 100%;
        .list_item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 30px 0;
            .left_box {
                display: flex;
                align-items: center;
                flex: 1;
                .info_box {
                    margin-left: 10px;
                    .title {
                        font-size: 18px;
                        font-weight: bold;
                        cursor: pointer;
                    }
                    .right_count {
                        font-size: 16px;
                        line-height: 60px;
                        .total {
                            color: #8E8E8E;
                        }
                    }
                    .time {
                        color: #8E8E8E;
                        font-size: 14px;
                    }
                }
                img {
                    width: 159px;
                    height: 113px;
                }
            }
            .right_box {
                width:100px;
                text-align: center;
                .fen {
                    font-size: 16px;
                    color: #8E8E8E;
                    .big {
                        font-size: 24px;
                        font-weight: bold;
                        color: #2767c4 ;
                    }
                }
                .btn_box {
                    margin-top: 10px;
                    .el-button {
                        background-color: #2767c4 ;
                        color: #fff;
                        border: none;
                        &:hover {
                            border-color: #2767c4 ;
                        }
                    }
                }
            }
            .redcolor {
                color: #2767c4 ;
                font-weight: bold;
            }
            .graycolor {
                color: #b3b3b3;
            }
        }
        .page_box {
            text-align: right;
        }
    }

    .jilu_box {

        .list_item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 30px 0;
            .left_box {
                display: flex;
                align-items: center;
                flex: 1;
                .info_box {
                    margin-left: 10px;
                    .title {
                        font-size: 18px;
                        font-weight: bold;
                        cursor: pointer;
                    }
                    .right_count {
                        font-size: 16px;
                        line-height: 60px;
                        .total {
                            color: #8E8E8E;
                        }
                    }
                    .time {
                        color: #8E8E8E;
                        font-size: 14px;
                    }
                }
                img {
                    width: 159px;
                    height: 113px;
                }
            }
            .right_box {
                width:100px;
                text-align: center;
                .fen {
                    font-size: 16px;
                    color: #8E8E8E;
                    .big {
                        font-size: 24px;
                        font-weight: bold;
                        color: #2767c4 ;
                    }
                }
                .btn_box {
                    margin-top: 10px;
                    .el-button {
                        background-color: #2767c4 ;
                        color: #fff;
                        border: none;
                        &:hover {
                            border-color: #2767c4 ;
                        }
                    }
                }
            }
            .redcolor {
                color: #2767c4 ;
                font-weight: bold;
            }
            .graycolor {
                color: #b3b3b3;
            }
        }
        .mulu_box {
            width: 100%;
            .mulu_item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px;
                box-sizing: border-box;
                margin: 20px 0; 
                cursor: pointer;
                &:hover {
                    background: rgba(248, 235, 235, 0.64);
                    .icons {
                        color: #2767c4 ;
                    }
                }
                .mulu_title {
                    font-size: 18px;
                    flex:1;
                    @include SingleRow;
                    .icons {
                        margin-right: 10px;
                    }
                }
                .mulu_jindu {
                    display: flex;
                    align-items: center;
                    color: #8E8D8D;
                    font-size: 14px;
                    .jindu_tiao {
                        margin-left: 10px;
                        .iconfont {
                            color: #5FBE13;
                            font-size: 20px;
                        }
                    }
                }
            }
        }


    }
    
}
</style>